import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import logoImg from '../../assets/crz_ems_logo_transperent.png';
import './Preloader.css';

const Preloader = ({ 
  isInline = false, 
  text = "CRZ ACADEMIC REVIEW", 
  subtext = "Education Management System" 
}) => {
  // Synchronously detect if the navbar header exists so there is zero initial layout shift
  const [hasNavbar, setHasNavbar] = useState(() => {
    return typeof document !== 'undefined' && !!document.querySelector('.navbar');
  });

  useEffect(() => {
    if (!isInline && typeof document !== 'undefined') {
      const navbarEl = document.querySelector('.navbar');
      setHasNavbar(!!navbarEl);
    }
  }, [isInline]);

  const content = (
    <div 
      className={`crz-preloader-backdrop ${isInline ? 'is-inline' : (hasNavbar ? 'with-header' : '')}`} 
      role="status" 
      aria-live="polite"
    >
      <div className="crz-preloader-card">
        {/* Orbital Animation Container */}
        <div className="crz-orbital-container">
          <div className="crz-ambient-glow" />
          <div className="crz-orbit-outer" />
          <div className="crz-orbit-satellite" />
          <div className="crz-orbit-inner" />
          
          {/* Central Logo Badge */}
          <div className="crz-logo-badge">
            <img
              src={logoImg}
              alt="CRZ Academic Review"
              className="crz-logo-img"
              loading="eager"
            />
          </div>
        </div>

        {/* Brand Typography & Progress Track */}
        <div className="crz-text-block">
          <div className="crz-brand-title">{text}</div>
          <div className="crz-brand-subtitle">{subtext}</div>
          <div className="crz-progress-track">
            <div className="crz-progress-bar" />
          </div>
        </div>
      </div>
    </div>
  );

  // If inline, render normally within parent container
  if (isInline || typeof document === 'undefined') {
    return content;
  }

  // If page-level, portal directly to document.body so parent styles don't distort it,
  // while positioning it cleanly below the header (top: 70px) with z-index: 1500
  return ReactDOM.createPortal(content, document.body);
};

export default React.memo(Preloader);
